/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Unprocessable entity
 * @export
 * @interface PostUiOpenwindowNewmailUnprocessableEntity
 */
export interface PostUiOpenwindowNewmailUnprocessableEntity {
    /**
     * Unprocessable entity message
     * @type {string}
     * @memberof PostUiOpenwindowNewmailUnprocessableEntity
     */
    error?: string;
}

/**
 * Check if a given object implements the PostUiOpenwindowNewmailUnprocessableEntity interface.
 */
export function instanceOfPostUiOpenwindowNewmailUnprocessableEntity(value: object): value is PostUiOpenwindowNewmailUnprocessableEntity {
    return true;
}

export function PostUiOpenwindowNewmailUnprocessableEntityFromJSON(json: any): PostUiOpenwindowNewmailUnprocessableEntity {
    return PostUiOpenwindowNewmailUnprocessableEntityFromJSONTyped(json, false);
}

export function PostUiOpenwindowNewmailUnprocessableEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostUiOpenwindowNewmailUnprocessableEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function PostUiOpenwindowNewmailUnprocessableEntityToJSON(json: any): PostUiOpenwindowNewmailUnprocessableEntity {
    return PostUiOpenwindowNewmailUnprocessableEntityToJSONTyped(json, false);
}

export function PostUiOpenwindowNewmailUnprocessableEntityToJSONTyped(value?: PostUiOpenwindowNewmailUnprocessableEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

